import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TicketReportDto } from '../../../../service/dto';
import { HttpTicketReportService } from '../../../../service/http-ticket-report.service';

@Component({
	selector: 'app-ticket-report-run-modal',
	standalone: false,
	templateUrl: './ticket-report-run-modal.component.html',
	styleUrls: ['./ticket-report-run-modal.component.scss'],
})
export class TicketReportRunModalComponent {
	@Input() reports!: TicketReportDto[];
	form: FormGroup;
	running = false;

	constructor(
		private fb: FormBuilder,
		private modalRef: NzModalRef,
		private httpService: HttpTicketReportService,
		private message: NzMessageService,
	) {
		const today = new Date();
		this.form = this.fb.group({
			startDate: [
				new Date(today.getFullYear(), today.getMonth(), 1),
				Validators.required,
			],
			endDate: [today, Validators.required],
			includeSummary: [false],
		});
	}

	// prevents 'To' being picked before 'From'
	disabledEndDate = (endValue: Date): boolean => {
		const start = this.form?.get('startDate')?.value;
		return (
			!!start && endValue.getTime() < new Date(start).setHours(0, 0, 0, 0)
		);
	};

	handleCancel(): void {
		if (this.running) return;
		this.modalRef.close(null);
	}

	handleDownload(): void {
		if (this.running) return;
		this.running = true;

		const startDate = this.form.get('startDate')!.value;
		const endDate = this.form.get('endDate')!.value;
		const includeSummary = this.form.get('includeSummary')!.value;

		this.httpService
			.run(startDate, endDate, includeSummary, this.reports)
			.subscribe({
				next: () => {
					this.message.success('Report generation started');
					this.running = false;
					this.modalRef.close(this.form.value);
				},
				error: (err) => {
					console.error('Report run failed:', err);
					this.message.error('Failed to start report generation');
					this.running = false;
				},
			});
	}
}
